import { render, staticRenderFns } from "./SistemaSuspenso.vue?vue&type=template&id=f351fb28&scoped=true"
import script from "./SistemaSuspenso.vue?vue&type=script&lang=js"
export * from "./SistemaSuspenso.vue?vue&type=script&lang=js"
import style0 from "./SistemaSuspenso.vue?vue&type=style&index=0&id=f351fb28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f351fb28",
  null
  
)

export default component.exports